/* QA-Audit-017 */
(function () {
  var DESKTOP_QUERY = '(min-width: 641px)';
  var ARROW_DESKTOP_QUERY = '(min-width: 1024px)';
  var OVERLAY_SELECTORS = ['#collection-sort-popover', '#collection-filter-drawer'];
  var resizeTimer;
  var scrollTimer;
  var overlayObservers = [];

  function orderToolbar(toolbar) {
    var group = toolbar.querySelector('.CollectionToolbar__Group');
    var layout = toolbar.querySelector('.CollectionToolbar__Item--layout');

    if (!group || !layout) {
      return;
    }

    if (window.matchMedia(DESKTOP_QUERY).matches) {
      toolbar.insertBefore(layout, group);
      toolbar.classList.add('CollectionToolbar--focus-ordered');
    } else {
      toolbar.insertBefore(group, layout);
      toolbar.classList.remove('CollectionToolbar--focus-ordered');
    }
  }

  function syncAllToolbars() {
    document.querySelectorAll('.CollectionToolbar').forEach(orderToolbar);
  }

  function syncOverlayInert() {
    OVERLAY_SELECTORS.forEach(function (selector) {
      var el = document.querySelector(selector);
      if (!el) return;
      el.inert = el.getAttribute('aria-hidden') !== 'false';
    });
  }

  function observeOverlayInert() {
    overlayObservers.forEach(function (observer) {
      observer.disconnect();
    });
    overlayObservers = [];

    OVERLAY_SELECTORS.forEach(function (selector) {
      var el = document.querySelector(selector);
      if (!el) return;

      var observer = new MutationObserver(syncOverlayInert);
      observer.observe(el, { attributes: true, attributeFilter: ['aria-hidden'] });
      overlayObservers.push(observer);
    });
  }

  function syncCategorySwitcherArrows() {
    var isArrowDesktop = window.matchMedia(ARROW_DESKTOP_QUERY).matches;

    document.querySelectorAll('[data-category-switcher]').forEach(function (switcher) {
      var prev = switcher.querySelector('[data-arrow-prev]');
      var next = switcher.querySelector('[data-arrow-next]');

      [prev, next].forEach(function (arrow) {
        if (!arrow) return;

        if (isArrowDesktop) {
          arrow.tabIndex = -1;
        } else {
          arrow.tabIndex = 0;
        }
      });
    });
  }

  function isTileVisible(tile, containerRect) {
    var tileRect = tile.getBoundingClientRect();
    return tileRect.right > containerRect.left + 1 && tileRect.left < containerRect.right - 1;
  }

  function syncOffscreenTiles() {
    var isArrowDesktop = window.matchMedia(ARROW_DESKTOP_QUERY).matches;

    document.querySelectorAll('[data-category-switcher] [data-scroll]').forEach(function (scroll) {
      var containerRect = scroll.getBoundingClientRect();

      scroll.querySelectorAll('[data-tile]').forEach(function (tile) {
        if (!isArrowDesktop) {
          tile.tabIndex = 0;
          return;
        }

        tile.tabIndex = isTileVisible(tile, containerRect) ? 0 : -1;
      });
    });
  }

  function bindCategorySwitcherScroll() {
    document.querySelectorAll('[data-category-switcher] [data-scroll]').forEach(function (scroll) {
      if (scroll.dataset.focusOrderScrollBound) return;
      scroll.dataset.focusOrderScrollBound = 'true';

      scroll.addEventListener('scroll', function () {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(syncOffscreenTiles, 100);
      });
    });
  }

  function syncAll() {
    syncAllToolbars();
    syncOverlayInert();
    observeOverlayInert();
    syncCategorySwitcherArrows();
    syncOffscreenTiles();
    bindCategorySwitcherScroll();
  }

  function debouncedSync() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(syncAll, 150);
  }

  document.addEventListener('DOMContentLoaded', syncAll);
  window.addEventListener('resize', debouncedSync);
  document.addEventListener('theme:loading:end', syncAll);
})();
